module.exports = __webpack_public_path__ + "static/media/sad_clock.698f5e1c.svg";